var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#EFE8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.834 18.568L17.739 13.518C17.9512 13.2456 18.0267 12.9308 17.956 12.6102C17.8947 12.3188 17.7154 12.0417 17.4466 11.8315L16.791 11.3107C16.2204 10.8568 15.5129 10.9046 15.1073 11.4254L14.6687 11.9944C14.6121 12.0656 14.6263 12.1707 14.697 12.228C14.697 12.228 15.8053 13.1166 15.8289 13.1358C15.9044 13.2074 15.961 13.303 15.9751 13.4176C15.9987 13.6422 15.8431 13.8524 15.612 13.8811C15.5035 13.8954 15.3998 13.862 15.3243 13.7999L14.1594 12.873C14.1028 12.8305 14.0179 12.8395 13.9707 12.8969L11.2023 16.4801C11.0231 16.7047 10.9618 16.9961 11.0231 17.278L11.3768 18.8116C11.3957 18.8928 11.4664 18.9502 11.5513 18.9502L13.1077 18.9311C13.3906 18.9263 13.6547 18.7973 13.834 18.568ZM16.0133 18.0903H18.5511C18.7987 18.0903 19.0001 18.2943 19.0001 18.5451C19.0001 18.7964 18.7987 18.9999 18.5511 18.9999H16.0133C15.7657 18.9999 15.5643 18.7964 15.5643 18.5451C15.5643 18.2943 15.7657 18.0903 16.0133 18.0903Z",
    fill: "#442580"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/edit icon.6a146a0ff912a6eab1d6f3eba431e3f1.svg";
export { ForwardRef as ReactComponent };